import React from "react";
import _PropTypes from "prop-types";
import AccessBenefits from "components/sell/AccessBenefits";
import UpgradeForm from "components/payments/UpgradeForm";
import UpgradePrice from "components/payments/UpgradePrice";
import { fetchUpgradePrice } from "./hooks";

export default function UpgradePage(props) {
  const {
    defaultErrorMessage,
    upgradePricePath,
    planCode,
    planCost,
    planDuration,
    planId,
    planInterval,
    alternateUpgradeDuration,
    alternateUpgradePath,
    showAlternatePlan,
    stripePaymentMethod,
    benefits,
    paypalEnvironment
  } = props;

  // I'm pulling these off separately because they are only used in test.
  // If they're undefined, the real elements will be used, but if components
  // are passed in, we can render a slightly different version of this component
  // to use in Capybara tests without actually talking to either Stripe or Paypal.
  const { PaypalButton, StripePaymentElement } = props;

  const upgradePrice = fetchUpgradePrice(props.upgradePrice, upgradePricePath);

  return (
    <div className="user-subscribe-sell">
      <div className="js-upgrade-form signup-subscribe-form lc-form signup-subscribe-form--checkout-variant">
        <div className="form-column-container">
          <div className="column-left-info form-column">
            <div className="selected-subscription-plan">
              <div className="title-container">
                <div className="title-4">
                  {planDuration === "annual" ? "Annual" : "Monthly"}{" "}
                  Subscription
                </div>
              </div>
              <div className="body-1">
                <span className="price monthly discounted">
                  {planCost} per {planInterval}
                </span>
                <span className="price actual monthly">
                  $<UpgradePrice upgradePrice={upgradePrice} /> USD for first{" "}
                  {planInterval}
                </span>
                <AccessBenefits benefits={benefits} />
              </div>
            </div>
            {showAlternatePlan && (
              <a
                className={`selected-subscription-plan__switch selected-subscription-plan__switch--${alternateUpgradeDuration}`} // eslint-disable-line max-len
                href={alternateUpgradePath}
              >
                Switch to {alternateUpgradeDuration} subscription
              </a>
            )}
          </div>
          <div className="column-right-plan-pay form-column">
            <div className="signup-upgrade-form__title title-4">
              Finish & Pay
            </div>
            <div className="pay-step">
              <p>
                <strong>
                  $<UpgradePrice upgradePrice={upgradePrice} /> USD due today,{" "}
                </strong>
                a prorated amount reflecting what you have already paid this
                billing period for your A<sup>+</sup> subscription.
              </p>
              <p>
                Renewals of your upgraded A+ Teacher {planDuration} subscription
                will be charged at the normal rate of {planCost}.
              </p>
              {stripePaymentMethod && (
                <p>
                  Your payment method: <strong>{stripePaymentMethod}</strong>
                </p>
              )}
              <UpgradeForm
                defaultErrorMessage={defaultErrorMessage}
                FormButtons={FormButtons}
                lastPaidWithStripe={!!stripePaymentMethod}
                PaypalButton={PaypalButton}
                paypalEnvironment={paypalEnvironment}
                planCode={planCode}
                planId={planId}
                StripePaymentElement={StripePaymentElement}
                upgradePrice={upgradePrice}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const FormButtons = ({ disabled, processing }) => (
  <button
    className="btn btn-a-plus btn-block form-button form-submit js-upgrade-button"
    disabled={disabled || processing}
    type="submit"
  >
    {processing ? "Processing..." : "Upgrade"}
  </button>
);
